<template>
  <!-- desktop & tablet -->
  <div class="hidden items-start gap-4 md:flex">
    <!-- sidebar -->
    <div class="flex w-1/4 shrink-0 flex-col">
      <button
        v-for="(item, idx) in data"
        :key="idx"
        class="cursor-pointer border-l-2 px-4 py-3 text-left"
        :class="
          currentIndex === idx
            ? 'rounded-r-lg border-green-800 bg-green-50'
            : 'border-grey-300'
        "
        @click="currentIndex = idx"
      >
        <component
          :is="item.icon"
          class="mb-4 h-8 w-8 lg:h-12 lg:w-12"
          :class="currentIndex === idx ? 'fill-green-800' : 'fill-grey-300'"
        />
        <span
          class="text-base text-grey-600"
          :class="{ 'font-medium !text-grey-700': currentIndex === idx }"
        >
          {{ item.label }}
        </span>
      </button>
    </div>
    <!-- main -->
    <div class="w-3/4">
      <div
        v-for="(tab, index) in data"
        v-show="currentIndex === index"
        :key="index"
      >
        <slot :name="tab.id"></slot>
      </div>
    </div>
  </div>

  <!-- mobile -->
  <div class="block md:hidden">
    <div v-for="(item, idx) in data" :key="idx">
      <button
        type="button"
        class="flex w-full items-center gap-2 border-l-2 px-6 py-3"
        :class="
          currentIndex === idx
            ? 'rounded-r-lg border-green-800 bg-green-50'
            : 'border-grey-300'
        "
        @click="currentIndex = idx"
      >
        <component
          :is="item.icon"
          class="h-4 w-4"
          :class="currentIndex === idx ? 'fill-green-800' : 'fill-grey-300'"
        />
        <span
          class="text-base text-grey-600"
          :class="{ 'font-medium !text-grey-700': currentIndex === idx }"
        >
          {{ item.label }}
        </span>
      </button>

      <Transition name="accordion">
        <div v-show="currentIndex === idx" class="grid">
          <div class="overflow-hidden">
            <div class="py-8">
              <div
                v-for="(tab, index) in data"
                v-show="currentIndex === index"
                :key="index"
              >
                <slot :name="tab.id"></slot>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  data: {
    id: string;
    label: string;
    icon: Component | string;
  }[];
}>();

const currentIndex = ref(0);
</script>
